import React, { useMemo } from 'react';
import { Bar } from 'react-chartjs-2';
import { tickColor, gridColor, baseFont, FALLBACK_COLORS } from './chartConstants';

const DepartmentBarChart = ({ departments }) => {
    const chartData = useMemo(() => {
        if (!Array.isArray(departments) || departments.length === 0) return null;
        const sorted = [...departments].sort((a, b) => b.tickets_count - a.tickets_count);
        return {
            labels: sorted.map(d => d.name),
            datasets: [{
                label: 'Tickets',
                data:  sorted.map(d => d.tickets_count),
                backgroundColor:      sorted.map((d, i) => d.color || FALLBACK_COLORS[i % FALLBACK_COLORS.length]),
                hoverBackgroundColor: sorted.map((d, i) => d.color || FALLBACK_COLORS[i % FALLBACK_COLORS.length]),
                borderWidth: 0,
            }],
        };
    }, [departments]);

    const options = {
        maintainAspectRatio: false,
        legend: { display: false },
        tooltips: {
            mode: 'index', intersect: false,
            backgroundColor: '#1F2937',
            titleFontFamily: baseFont, titleFontSize: 12, titleFontStyle: 'bold',
            bodyFontFamily: baseFont,  bodyFontSize: 12,
            xPadding: 10, yPadding: 10,
            callbacks: { label: (item) => ` ${item.yLabel} ticket${item.yLabel !== 1 ? 's' : ''}` },
        },
        scales: {
            xAxes: [{ gridLines: { display: false }, ticks: { fontColor: tickColor, fontFamily: baseFont, fontSize: 11, maxRotation: 30, autoSkip: false } }],
            yAxes: [{ gridLines: { color: gridColor }, ticks: { fontColor: tickColor, fontFamily: baseFont, fontSize: 11, beginAtZero: true, callback: (v) => Number.isInteger(v) ? v : null } }],
        },
    };

    if (!chartData) return <div style={{ color: tickColor, padding: 20 }}>No department data available</div>;
    return <div style={{ height: '100%', minHeight: 160 }}><Bar data={chartData} options={options} /></div>;
};

export default DepartmentBarChart;
